// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import carousel from 'v-owl-carousel'
import VueProgressBar from 'vue-progressbar'
import store from './store'
import VueElementLoading from 'vue-element-loading'
import * as VueGoogleMaps from 'vue2-google-maps'
import ToggleButton from 'vue-js-toggle-button'
// css and scss files include
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/font-awesome.min.css'
import './assets/index.scss'

// remove below file for change color
// import './assets/css/color/color-2.css'
Vue.use(ToggleButton)
Vue.component('VueElementLoading', VueElementLoading)
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.component('carousel', carousel)
Vue.config.productionTip = false
var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC1HL28K4TJ5XDx5lU-byjRaNAPc_ELfBE',
    libraries: 'places,geometry',
  },
})

const options = {
  color: '#7DEADF',
  failedColor: '#7DEADF',
  thickness: '4px',
  transition: {
    speed: '0.5s',
    opacity: '0.10s',
    termination: 300,
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
}
Vue.use(VueProgressBar, options)

export const vues = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
})

// new Vue({
//   el: '#appwidg',
//   store,
//   router,
//   components: { AppWidg },
//   template: '<AppWidg/>',
// })



// WEBPACK FOOTER //
// ./src/main.js